// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --orange-50:  #FFF8F4;
  --orange-100: #FEF3EE;
  --orange-200: #F0DCC8;
  --orange-300: #FDCFB5;
  --orange-400: #E05A1A;
  --orange-500: #C84B0F;
  --orange-600: #A33A08;
  --white:      #FFFFFF;
  --grey-50:    #F9FAFB;
  --grey-100:   #F3F4F6;
  --grey-200:   #E5E7EB;
  --grey-400:   #9CA3AF;
  --grey-600:   #4B5563;
  --grey-700:   #374151;
  --grey-900:   #111827;
  --shadow-sm:  0 1px 3px rgba(200,75,15,0.08);
  --shadow-md:  0 4px 16px rgba(200,75,15,0.10);
  --radius-sm:  8px;
  --radius-md:  12px;
  --radius-lg:  16px;
}

* { box-sizing: border-box; margin: 0; padding: 0; }

body {
  font-family: 'DM Sans', -apple-system, BlinkMacSystemFont, sans-serif;
  background: var(--orange-50);
  color: var(--grey-900);
  font-size: 14px;
  -webkit-font-smoothing: antialiased;
}

/* Layout */
.app-shell { display: flex; height: 100vh; overflow: hidden; }
.sidebar {
  width: 230px;
  background: var(--white);
  border-right: 1px solid var(--orange-200);
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  overflow-y: auto;
  position: relative;
}
.main-content { flex: 1 1; display: flex; flex-direction: column; overflow: hidden; }
.topbar {
  height: 56px;
  background: var(--white);
  border-bottom: 1px solid var(--orange-200);
  display: flex;
  align-items: center;
  padding: 0 24px;
  gap: 12px;
  flex-shrink: 0;
}
.page-body { flex: 1 1; overflow-y: auto; padding: 28px 32px; }

/* Sidebar */
.sidebar-logo {
  padding: 18px 16px;
  border-bottom: 1px solid var(--orange-200);
  display: flex;
  align-items: center;
  gap: 10px;
}
.sidebar-logo-icon {
  width: 34px; height: 34px;
  background: var(--orange-500);
  border-radius: 9px;
  display: flex; align-items: center; justify-content: center;
  font-weight: 800; font-size: 15px; color: #fff; flex-shrink: 0;
}
.sidebar-logo-text { font-weight: 800; font-size: 14px; color: var(--grey-900); line-height: 1.2; }
.sidebar-logo-text span { display: block; font-size: 10px; font-weight: 500; color: var(--grey-400); }
.sidebar-section-label {
  font-size: 10px; font-weight: 700; color: var(--grey-400);
  text-transform: uppercase; letter-spacing: 0.07em;
  padding: 12px 16px 4px;
}
.nav-item {
  display: flex; align-items: center; gap: 9px;
  padding: 9px 16px; cursor: pointer;
  color: var(--grey-600); font-size: 13px; font-weight: 500;
  border-left: 2.5px solid transparent;
  text-decoration: none; transition: all 0.13s;
}
.nav-item:hover { background: var(--orange-100); color: var(--orange-500); }
.nav-item.active {
  background: var(--orange-100);
  color: var(--orange-500);
  border-left-color: var(--orange-500);
  font-weight: 600;
}

/* Loader */
.loader {
  width: 22px; height: 22px;
  border: 2.5px solid var(--orange-200);
  border-top-color: var(--orange-500);
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
}
@keyframes spin { to { transform: rotate(360deg); } }

/* Cards */
.card {
  background: var(--white);
  border: 1px solid var(--orange-200);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-sm);
}
.metric-card {
  background: var(--white);
  border: 1px solid var(--orange-200);
  border-radius: var(--radius-md);
  padding: 18px 20px;
  box-shadow: var(--shadow-sm);
}

/* Table */
table { width: 100%; border-collapse: collapse; }
th {
  padding: 10px 16px;
  text-align: left;
  font-size: 11px; font-weight: 700;
  color: var(--grey-400);
  text-transform: uppercase; letter-spacing: 0.05em;
  background: var(--orange-50);
  border-bottom: 1px solid var(--orange-200);
  white-space: nowrap;
}
td { padding: 11px 16px; border-bottom: 1px solid #FDF0E8; }
tr:last-child td { border-bottom: none; }
tbody tr:hover td { background: var(--orange-50); }

/* Badges */
.badge {
  display: inline-flex; align-items: center; gap: 4px;
  padding: 3px 9px; border-radius: 20px;
  font-size: 11px; font-weight: 700;
}
.badge-green  { background: #F0FDF4; color: #15803D; }
.badge-orange { background: var(--orange-100); color: var(--orange-500); }
.badge-blue   { background: #EEF2FF; color: #1D4ED8; }
.badge-purple { background: #F5F3FF; color: #7C3AED; }
.badge-grey   { background: var(--grey-100); color: var(--grey-600); }
.badge-red    { background: #FEF2F2; color: #B91C1C; }

/* Buttons */
.btn {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 9px 18px; border-radius: 9px; border: none;
  font-size: 13px; font-weight: 600; cursor: pointer;
  font-family: inherit; transition: all 0.13s;
}
.btn-primary { background: var(--orange-500); color: #fff; }
.btn-primary:hover { background: var(--orange-600); }
.btn-primary:disabled { opacity: 0.6; cursor: not-allowed; }
.btn-outline { background: transparent; color: var(--orange-500); border: 1px solid var(--orange-300); }
.btn-outline:hover { background: var(--orange-100); }
.btn-ghost { background: transparent; color: var(--grey-600); border: 1px solid var(--orange-200); }
.btn-ghost:hover { background: var(--orange-50); }

/* Form */
.form-label { display: block; font-size: 11px; font-weight: 700; color: var(--grey-400); text-transform: uppercase; letter-spacing: 0.06em; margin-bottom: 6px; }
.form-input {
  width: 100%; padding: 9px 12px;
  border: 1px solid var(--orange-200); border-radius: 9px;
  font-size: 13px; color: var(--grey-900); background: #FFFCFA;
  outline: none; font-family: inherit;
  transition: border-color 0.13s;
}
.form-input:focus { border-color: var(--orange-500); }

/* Modal overlay */
.modal-overlay {
  position: fixed; inset: 0;
  background: rgba(0,0,0,0.42);
  z-index: 1000;
  display: flex; align-items: center; justify-content: center;
  padding: 24px;
}
.modal {
  background: #fff;
  border-radius: var(--radius-lg);
  width: 100%; max-width: 560px;
  max-height: 88vh; overflow-y: auto;
  box-shadow: 0 24px 80px rgba(0,0,0,0.18);
}
`, "",{"version":3,"sources":["webpack://./src/styles/global.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,4CAA4C;EAC5C,6CAA6C;EAC7C,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,IAAI,sBAAsB,EAAE,SAAS,EAAE,UAAU,EAAE;;AAEnD;EACE,qEAAqE;EACrE,4BAA4B;EAC5B,sBAAsB;EACtB,eAAe;EACf,mCAAmC;AACrC;;AAEA,WAAW;AACX,aAAa,aAAa,EAAE,aAAa,EAAE,gBAAgB,EAAE;AAC7D;EACE,YAAY;EACZ,wBAAwB;EACxB,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;AACA,gBAAgB,SAAO,EAAE,aAAa,EAAE,sBAAsB,EAAE,gBAAgB,EAAE;AAClF;EACE,YAAY;EACZ,wBAAwB;EACxB,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,cAAc;AAChB;AACA,aAAa,SAAO,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;;AAE5D,YAAY;AACZ;EACE,kBAAkB;EAClB,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,WAAW,EAAE,YAAY;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,gBAAgB,EAAE,eAAe,EAAE,WAAW,EAAE,cAAc;AAChE;AACA,qBAAqB,gBAAgB,EAAE,eAAe,EAAE,sBAAsB,EAAE,gBAAgB,EAAE;AAClG,0BAA0B,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE,sBAAsB,EAAE;AACrG;EACE,eAAe,EAAE,gBAAgB,EAAE,sBAAsB;EACzD,yBAAyB,EAAE,sBAAsB;EACjD,sBAAsB;AACxB;AACA;EACE,aAAa,EAAE,mBAAmB,EAAE,QAAQ;EAC5C,iBAAiB,EAAE,eAAe;EAClC,sBAAsB,EAAE,eAAe,EAAE,gBAAgB;EACzD,oCAAoC;EACpC,qBAAqB,EAAE,qBAAqB;AAC9C;AACA,kBAAkB,6BAA6B,EAAE,wBAAwB,EAAE;AAC3E;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,WAAW,EAAE,YAAY;EACzB,qCAAqC;EACrC,mCAAmC;EACnC,kBAAkB;EAClB,oCAAoC;AACtC;AACA,kBAAkB,KAAK,yBAAyB,EAAE,EAAE;;AAEpD,UAAU;AACV;EACE,wBAAwB;EACxB,mCAAmC;EACnC,+BAA+B;EAC/B,4BAA4B;AAC9B;AACA;EACE,wBAAwB;EACxB,mCAAmC;EACnC,+BAA+B;EAC/B,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA,UAAU;AACV,QAAQ,WAAW,EAAE,yBAAyB,EAAE;AAChD;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe,EAAE,gBAAgB;EACjC,sBAAsB;EACtB,yBAAyB,EAAE,sBAAsB;EACjD,4BAA4B;EAC5B,0CAA0C;EAC1C,mBAAmB;AACrB;AACA,KAAK,kBAAkB,EAAE,gCAAgC,EAAE;AAC3D,mBAAmB,mBAAmB,EAAE;AACxC,oBAAoB,4BAA4B,EAAE;;AAElD,WAAW;AACX;EACE,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ;EACnD,gBAAgB,EAAE,mBAAmB;EACrC,eAAe,EAAE,gBAAgB;AACnC;AACA,gBAAgB,mBAAmB,EAAE,cAAc,EAAE;AACrD,gBAAgB,6BAA6B,EAAE,wBAAwB,EAAE;AACzE,gBAAgB,mBAAmB,EAAE,cAAc,EAAE;AACrD,gBAAgB,mBAAmB,EAAE,cAAc,EAAE;AACrD,gBAAgB,2BAA2B,EAAE,sBAAsB,EAAE;AACrE,gBAAgB,mBAAmB,EAAE,cAAc,EAAE;;AAErD,YAAY;AACZ;EACE,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ;EACnD,iBAAiB,EAAE,kBAAkB,EAAE,YAAY;EACnD,eAAe,EAAE,gBAAgB,EAAE,eAAe;EAClD,oBAAoB,EAAE,qBAAqB;AAC7C;AACA,eAAe,6BAA6B,EAAE,WAAW,EAAE;AAC3D,qBAAqB,6BAA6B,EAAE;AACpD,wBAAwB,YAAY,EAAE,mBAAmB,EAAE;AAC3D,eAAe,uBAAuB,EAAE,wBAAwB,EAAE,mCAAmC,EAAE;AACvG,qBAAqB,6BAA6B,EAAE;AACpD,aAAa,uBAAuB,EAAE,sBAAsB,EAAE,mCAAmC,EAAE;AACnG,mBAAmB,4BAA4B,EAAE;;AAEjD,SAAS;AACT,cAAc,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE,sBAAsB,EAAE,yBAAyB,EAAE,sBAAsB,EAAE,kBAAkB,EAAE;AAChK;EACE,WAAW,EAAE,iBAAiB;EAC9B,mCAAmC,EAAE,kBAAkB;EACvD,eAAe,EAAE,sBAAsB,EAAE,mBAAmB;EAC5D,aAAa,EAAE,oBAAoB;EACnC,8BAA8B;AAChC;AACA,oBAAoB,+BAA+B,EAAE;;AAErD,kBAAkB;AAClB;EACE,eAAe,EAAE,QAAQ;EACzB,4BAA4B;EAC5B,aAAa;EACb,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,WAAW,EAAE,gBAAgB;EAC7B,gBAAgB,EAAE,gBAAgB;EAClC,wCAAwC;AAC1C","sourcesContent":[":root {\n  --orange-50:  #FFF8F4;\n  --orange-100: #FEF3EE;\n  --orange-200: #F0DCC8;\n  --orange-300: #FDCFB5;\n  --orange-400: #E05A1A;\n  --orange-500: #C84B0F;\n  --orange-600: #A33A08;\n  --white:      #FFFFFF;\n  --grey-50:    #F9FAFB;\n  --grey-100:   #F3F4F6;\n  --grey-200:   #E5E7EB;\n  --grey-400:   #9CA3AF;\n  --grey-600:   #4B5563;\n  --grey-700:   #374151;\n  --grey-900:   #111827;\n  --shadow-sm:  0 1px 3px rgba(200,75,15,0.08);\n  --shadow-md:  0 4px 16px rgba(200,75,15,0.10);\n  --radius-sm:  8px;\n  --radius-md:  12px;\n  --radius-lg:  16px;\n}\n\n* { box-sizing: border-box; margin: 0; padding: 0; }\n\nbody {\n  font-family: 'DM Sans', -apple-system, BlinkMacSystemFont, sans-serif;\n  background: var(--orange-50);\n  color: var(--grey-900);\n  font-size: 14px;\n  -webkit-font-smoothing: antialiased;\n}\n\n/* Layout */\n.app-shell { display: flex; height: 100vh; overflow: hidden; }\n.sidebar {\n  width: 230px;\n  background: var(--white);\n  border-right: 1px solid var(--orange-200);\n  display: flex;\n  flex-direction: column;\n  flex-shrink: 0;\n  overflow-y: auto;\n  position: relative;\n}\n.main-content { flex: 1; display: flex; flex-direction: column; overflow: hidden; }\n.topbar {\n  height: 56px;\n  background: var(--white);\n  border-bottom: 1px solid var(--orange-200);\n  display: flex;\n  align-items: center;\n  padding: 0 24px;\n  gap: 12px;\n  flex-shrink: 0;\n}\n.page-body { flex: 1; overflow-y: auto; padding: 28px 32px; }\n\n/* Sidebar */\n.sidebar-logo {\n  padding: 18px 16px;\n  border-bottom: 1px solid var(--orange-200);\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.sidebar-logo-icon {\n  width: 34px; height: 34px;\n  background: var(--orange-500);\n  border-radius: 9px;\n  display: flex; align-items: center; justify-content: center;\n  font-weight: 800; font-size: 15px; color: #fff; flex-shrink: 0;\n}\n.sidebar-logo-text { font-weight: 800; font-size: 14px; color: var(--grey-900); line-height: 1.2; }\n.sidebar-logo-text span { display: block; font-size: 10px; font-weight: 500; color: var(--grey-400); }\n.sidebar-section-label {\n  font-size: 10px; font-weight: 700; color: var(--grey-400);\n  text-transform: uppercase; letter-spacing: 0.07em;\n  padding: 12px 16px 4px;\n}\n.nav-item {\n  display: flex; align-items: center; gap: 9px;\n  padding: 9px 16px; cursor: pointer;\n  color: var(--grey-600); font-size: 13px; font-weight: 500;\n  border-left: 2.5px solid transparent;\n  text-decoration: none; transition: all 0.13s;\n}\n.nav-item:hover { background: var(--orange-100); color: var(--orange-500); }\n.nav-item.active {\n  background: var(--orange-100);\n  color: var(--orange-500);\n  border-left-color: var(--orange-500);\n  font-weight: 600;\n}\n\n/* Loader */\n.loader {\n  width: 22px; height: 22px;\n  border: 2.5px solid var(--orange-200);\n  border-top-color: var(--orange-500);\n  border-radius: 50%;\n  animation: spin 0.7s linear infinite;\n}\n@keyframes spin { to { transform: rotate(360deg); } }\n\n/* Cards */\n.card {\n  background: var(--white);\n  border: 1px solid var(--orange-200);\n  border-radius: var(--radius-md);\n  box-shadow: var(--shadow-sm);\n}\n.metric-card {\n  background: var(--white);\n  border: 1px solid var(--orange-200);\n  border-radius: var(--radius-md);\n  padding: 18px 20px;\n  box-shadow: var(--shadow-sm);\n}\n\n/* Table */\ntable { width: 100%; border-collapse: collapse; }\nth {\n  padding: 10px 16px;\n  text-align: left;\n  font-size: 11px; font-weight: 700;\n  color: var(--grey-400);\n  text-transform: uppercase; letter-spacing: 0.05em;\n  background: var(--orange-50);\n  border-bottom: 1px solid var(--orange-200);\n  white-space: nowrap;\n}\ntd { padding: 11px 16px; border-bottom: 1px solid #FDF0E8; }\ntr:last-child td { border-bottom: none; }\ntbody tr:hover td { background: var(--orange-50); }\n\n/* Badges */\n.badge {\n  display: inline-flex; align-items: center; gap: 4px;\n  padding: 3px 9px; border-radius: 20px;\n  font-size: 11px; font-weight: 700;\n}\n.badge-green  { background: #F0FDF4; color: #15803D; }\n.badge-orange { background: var(--orange-100); color: var(--orange-500); }\n.badge-blue   { background: #EEF2FF; color: #1D4ED8; }\n.badge-purple { background: #F5F3FF; color: #7C3AED; }\n.badge-grey   { background: var(--grey-100); color: var(--grey-600); }\n.badge-red    { background: #FEF2F2; color: #B91C1C; }\n\n/* Buttons */\n.btn {\n  display: inline-flex; align-items: center; gap: 6px;\n  padding: 9px 18px; border-radius: 9px; border: none;\n  font-size: 13px; font-weight: 600; cursor: pointer;\n  font-family: inherit; transition: all 0.13s;\n}\n.btn-primary { background: var(--orange-500); color: #fff; }\n.btn-primary:hover { background: var(--orange-600); }\n.btn-primary:disabled { opacity: 0.6; cursor: not-allowed; }\n.btn-outline { background: transparent; color: var(--orange-500); border: 1px solid var(--orange-300); }\n.btn-outline:hover { background: var(--orange-100); }\n.btn-ghost { background: transparent; color: var(--grey-600); border: 1px solid var(--orange-200); }\n.btn-ghost:hover { background: var(--orange-50); }\n\n/* Form */\n.form-label { display: block; font-size: 11px; font-weight: 700; color: var(--grey-400); text-transform: uppercase; letter-spacing: 0.06em; margin-bottom: 6px; }\n.form-input {\n  width: 100%; padding: 9px 12px;\n  border: 1px solid var(--orange-200); border-radius: 9px;\n  font-size: 13px; color: var(--grey-900); background: #FFFCFA;\n  outline: none; font-family: inherit;\n  transition: border-color 0.13s;\n}\n.form-input:focus { border-color: var(--orange-500); }\n\n/* Modal overlay */\n.modal-overlay {\n  position: fixed; inset: 0;\n  background: rgba(0,0,0,0.42);\n  z-index: 1000;\n  display: flex; align-items: center; justify-content: center;\n  padding: 24px;\n}\n.modal {\n  background: #fff;\n  border-radius: var(--radius-lg);\n  width: 100%; max-width: 560px;\n  max-height: 88vh; overflow-y: auto;\n  box-shadow: 0 24px 80px rgba(0,0,0,0.18);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
